import styled from 'styled-components';
import { StockModelPageStyled } from '../StockModelPageStyled';

export const StockModelPageStyledOV = styled(StockModelPageStyled)`
    display: flex;
    flex-direction: column;
`;
